import { icons } from './icons';
class Branch {
  constructor(location, branchList) {
    // Store all branch data
    $.each(location, (key, value) => {
      this[key] = value;
    });

    this.element = $(`div[data-id="${this.id}"]`);

    // if (this.atmOnly) {
    //   this.element.addClass('atm');
    // } else {
    //   this.element.addClass('branch');
    // }

    this.branchList = branchList;

    // Select branch when element is clicked
    this.element.on('click', e => {
      this.select(e);
    });
  }

  select(e) {
    this.element.addClass('selected');
    this.marker.addClass('current-marker');
    this.branchList.select(this, e);
  }

  deselect() {
    this.element.removeClass('selected hidden');
    this.marker.removeClass('current-marker');
  }

  set distance(miles) {
    if (this.element) {
      if (miles) {
        const text = `${parseFloat(miles.toFixed(2))}mi`;
        this.element.find('.distance').text(text);
      } else {
        this.element.find('.distance').text('');
      }
    }

    this._distance = miles;
  }

  get distance() {
    if (this._distance === undefined) this._distance = null;
    return this._distance;
  }

  getTypeIcon() {
    return this.atmOnly
      ? `<div class="location-type atm"><span>ATM Only</span>${icons.atm}</div>`
      : `<div class="location-type branch"><span>Branch</span>${icons.branch}</div>`;

    // if (this.atmOnly) {
    //   return $(
    //     `<div class="location-type atm"><span>ATM Only</span>${icons.atm}</div>`
    //   );
    // } else {
    //   return $(
    //     `<div class="location-type branch"><span>Branch</span>${icons.branch}</div>`
    //   );
    // }
  }
}
export default Branch;
